import { render, staticRenderFns } from "./change-summary.vue?vue&type=template&id=07611d79&scoped=true"
import script from "./change-summary.vue?vue&type=script&lang=js"
export * from "./change-summary.vue?vue&type=script&lang=js"
import style0 from "./change-summary.vue?vue&type=style&index=0&id=07611d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07611d79",
  null
  
)

export default component.exports